import './App.css';
import Main from './Components/Main';

function App() {
  return (
    <div>
      <Main/>
       <h1 className='text-center '> Wellcome to my <span className='text-primary'>project library</span></h1>
       <p className='text-center'>This library includes my react projects</p>
    </div>
  );
}

export default App;
